import { leaseCompanyMst } from '@libs/domain';
import { LabelField } from '@ps-smart-cp/ppfw-client';
import { useEffect, useState } from 'react';
import { fetchMst } from './repositories';

interface LabelProps {
  code: string;
}

export function Label(props: LabelProps) {
  const [mstName, setMstName] = useState('');

  useEffect(() => {
    void (async () => {
      try {
        const mst = await fetchMst({ code: props.code });
        setMstName(mst.name);
      } catch {
        setMstName('');
      }
    })();
  }, []);

  return (
    <LabelField
      itemName={leaseCompanyMst.names.laCompanyMstCode}
      value={props.code}
      postLabel={mstName}
      bgColor="white"
    />
  );
}
